import React from 'react';
import { Typography, List, ListItem, ListItemText } from '@mui/material';
import { ResumeCard } from './components';

interface ResumeContentProps {
  title?: string;
  company?: string;
  institution?: string;
  date: string;
  content: string[];
}

export const ResumeContent = ({
  title,
  company,
  institution,
  date,
  content,
}: ResumeContentProps): React.ReactNode => {
  return (
    <ResumeCard>
      {title && (
        <Typography
          variant='h5'
          sx={{
            mb: 2,
            fontWeight: 'bold',
            color: 'primary.main',
          }}
        >
          {title}
        </Typography>
      )}

      {company && (
        <Typography
          variant='h6'
          sx={{
            mb: 1,
            fontWeight: 500,
            color: 'text.secondary',
          }}
        >
          Company: {company}
        </Typography>
      )}

      {institution && (
        <Typography
          variant='h6'
          sx={{
            mb: 1,
            fontWeight: 500,
            color: 'text.secondary',
          }}
        >
          Institution: {institution}
        </Typography>
      )}

      <Typography
        variant='body2'
        sx={{
          mb: 2,
          fontStyle: 'italic',
          color: 'text.secondary',
        }}
      >
        {date}
      </Typography>

      <List sx={{ p: 0 }}>
        {content.map((value, index) => (
          <ListItem
            key={index}
            sx={{
              p: 0,
              mb: 1,
              '&:before': {
                content: '"‣"',
                color: 'primary.main',
                fontWeight: 'bold',
                mr: 1,
              },
            }}
          >
            <ListItemText
              primary={value}
              sx={{
                '& .MuiListItemText-primary': {
                  fontSize: '0.9rem',
                  lineHeight: 1.6,
                },
              }}
            />
          </ListItem>
        ))}
      </List>
    </ResumeCard>
  );
};
